/* ===== Slideshow Logic ===== */
import { applyDemoPlaceholders } from './demo-placeholders.js?v=83.58';
import { $ } from '../utils/helpers.js?v=83.58';
import { getCurrentSettings } from '../services/settings.js?v=83.58';
import { updateTriesCounter } from './admin.js?v=83.58';
import { sanitizeExternalHttpUrl, sanitizeImageSrc } from '../utils/url.js?v=83.58';
import { getPublicClientSlug } from '../services/public-client.js?v=83.58';
import { applyClientPromoGalleryUI, hideGenericPromoGallery } from './client-promo-gallery.js?v=83.58';
import { applyEventModuleUI, isEventVisible } from './event-module.js?v=83.58';
import {
  applyLoyaltyModuleUI,
  isLoyaltyVisible
} from './loyalty-module.js?v=83.58';
import { syncPrimaryModuleClientUI } from './client-primary-module.js?v=83.58';
import { hideCustomIntruders, clearCustomIntruderStyles, CUSTOM_INTRUDER_IDS } from './client-custom-intruders.js?v=83.58';
import { clearConnectIntruderStyles, CONNECT_LEAK_IDS, hideConnectOnlyChrome } from './client-connect-template.js?v=83.58';
import { ensureLoyaltySettingsLoaded } from '../services/loyalty.js?v=83.58';
import { applyClientLayoutConfig } from './client-layout-renderer.js?v=83.58';
import { applyClientPublicBrandLogo } from '../utils/public-bootstrap-branding.js?v=83.58';
import { applyMenuModuleClientUI } from './menu-module-client.js?v=83.58';
import { applyContactModuleClientUI } from './contact-module-client.js?v=83.58';
import {
  applyClientTemplateToPage,
  applyElegantTemplateDomFixes,
  applyModernTemplateDomFixes,
  applyDynamicTemplateDomFixes,
  applyFutureTemplateDomFixes,
  applyMinimalTemplateDomFixes,
  applyStandardTemplateDomFixes,
  syncDynamicClientCopy,
  syncDynamicCentralHero,
  syncDynamicTemplateAccent,
  syncFutureClientCopy,
  syncFutureTemplateAccent,
  syncMinimalOffersCard,
  syncMinimalClientCopy,
  syncClientTemplateHeader,
  syncElegantClientCopy,
  syncCompactReviewCard,
  finalizeElegantReviewVisibility,
  getClientTemplateStyleFromSettings,
  getActiveClientTemplateStyleForUi,
  isElegantTemplateActive,
  isModernTemplateActive,
  isDynamicTemplateActive,
  isFutureTemplateActive,
  isMinimalTemplateActive,
  isConnectTemplateActive,
  isAlfaTemplateActive,
  isCustomTemplateActive,
  isAvvaTemplateActive,
  isPosterTemplateActive,
  isStandardTemplateActive,
  isAiPreviewStandardPending,
  isStandardVisualActive,
  syncElegantTopChrome
} from './client-template-style.js?v=83.58';

let slideshowInterval = null;

const CUSTOM_STAGE_CLEAR_PROPS = [
  'display',
  'flex',
  'visibility',
  'opacity',
  'height',
  'min-height',
  'max-height',
  'width',
  'min-width',
  'max-width',
  'padding',
  'padding-bottom',
  'padding-top',
  'padding-left',
  'padding-right',
  'margin',
  'margin-left',
  'margin-right',
  'overflow',
  'position',
  'inset',
  'top',
  'left',
  'right',
  'bottom',
  'z-index',
  'pointer-events',
  'order',
  'transform',
  'clip',
  'clip-path',
  'grid-template-rows'
];

function forceAvvaLayoutShell() {
  if (!isAvvaTemplateActive()) return;
  ['clientPremiumStage', 'clientHeroActions'].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.style.setProperty('display', 'contents', 'important');
    el.style.setProperty('flex', '0 0 auto', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('padding-bottom', '0', 'important');
    el.style.setProperty('gap', '0', 'important');
  });
  const dock = document.getElementById('clientPremiumBottomDock');
  if (dock) {
    dock.style.removeProperty('display');
    dock.style.removeProperty('position');
    dock.style.removeProperty('bottom');
    dock.style.removeProperty('left');
    dock.style.removeProperty('right');
    dock.style.removeProperty('top');
    dock.style.removeProperty('height');
    dock.style.removeProperty('min-height');
  }
  try {
    if (!isPosterTemplateActive()) hideConnectOnlyChrome();
  } catch (_) {
    /* ignore */
  }
}

/** Oferte: un singur card — generic SAU Connect/Alfa, niciodată ambele. */
export function enforcePromoIsolation(settings = getCurrentSettings()) {
  const selfManaged =
    isConnectTemplateActive() || isAlfaTemplateActive() || isCustomTemplateActive();
  if (selfManaged) {
    hideGenericPromoGallery();
  } else {
    try {
      /* Afiș / Tablă folosesc slideshow-ul „connect-only” ca hero — nu-l ascundem */
      if (!isPosterTemplateActive()) hideConnectOnlyChrome();
    } catch (_) {
      /* ignore */
    }
    applyClientPromoGalleryUI(settings || {});
  }
  forceAvvaLayoutShell();
}

/** Re-aplică izolarea după sync-uri async (Connect/Alfa rAF/timeout). */
export function schedulePromoIsolation(settings = getCurrentSettings()) {
  enforcePromoIsolation(settings);
  requestAnimationFrame(() => {
    enforcePromoIsolation(getCurrentSettings() || settings);
    setTimeout(() => enforcePromoIsolation(getCurrentSettings() || settings), 140);
  });
}

function clearPremiumStageCustomInline() {
  // Curăță inline-uri reziduale (poziție/display) lăsate de Custom pe toate elementele premium.
  // Include și „intruderii" pe care Custom îi muta off-screen (position:absolute; left:-9999px),
  // ca să nu rămână plutind pe alte teme după ce ieși din Custom.
  const ids = new Set([
    'clientPremiumStage', 'clientHeroActions', 'clientPremiumSectionDuo',
    'clientPremiumBottomDock', 'clientPremiumCenterCta', 'clientPremiumSectionPromo',
    'layoutBlockMenu', 'layoutBlockReview', 'layoutBlockPromo', 'layoutBlockCampaign',
    'layoutBlockLoyalty', 'layoutBlockEvent',
    'locationMenuBtn', 'feedbackBtn',
    ...(Array.isArray(CUSTOM_INTRUDER_IDS) ? CUSTOM_INTRUDER_IDS : []),
    ...(Array.isArray(CONNECT_LEAK_IDS) ? CONNECT_LEAK_IDS : [])
  ]);
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    CUSTOM_STAGE_CLEAR_PROPS.forEach((prop) => el.style.removeProperty(prop));
    el.classList.remove('client-custom-duo-tile');
  });
  // Resetare completă a stilurilor de „ascundere intrus" lăsate de Custom
  try { clearCustomIntruderStyles(); } catch (_) { /* ignore */ }
  try { clearConnectIntruderStyles(); } catch (_) { /* ignore */ }
  document.getElementById('clientPage')?.querySelectorAll('.client-custom-duo-tile')
    .forEach((el) => el.classList.remove('client-custom-duo-tile'));
  /* Avva: clear-ul de mai sus scoate display:contents — reafirmă imediat */
  forceAvvaLayoutShell();
  /* După clear pe CONNECT_LEAK, cardurile pot reapărea — reascunde pe teme non-Connect */
  if (!isConnectTemplateActive() && !isAlfaTemplateActive() && !isCustomTemplateActive() && !isPosterTemplateActive()) {
    try {
      hideConnectOnlyChrome();
    } catch (_) {
      /* ignore */
    }
  }
}

function runCustomTemplateSync(settings, { promoOnly = false } = {}) {
  hideCustomIntruders();
  return import('./client-custom-template.js?v=83.58')
    .then((m) => {
      if (promoOnly) {
        m.applyCustomAccentColor?.(settings);
        m.syncCustomPromoRow?.(settings);
        m.finalizeCustomDuoChrome?.(settings);
        hideCustomIntruders();
        return;
      }
      m.syncCustomTemplate?.(settings);
      m.finalizeCustomDuoChrome?.(settings);
      hideCustomIntruders();
    })
    .catch(() => {});
}

const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'tiktok'];

function syncReviewSocialDividers(bar) {
  if (!bar) return;
  bar.querySelectorAll('.client-premium-social-divider').forEach((el) => el.remove());
  const visibleBtns = SOCIAL_PLATFORMS.map((platform) => {
    const cap = platform.charAt(0).toUpperCase() + platform.slice(1);
    return document.getElementById(`socialBtn${cap}`);
  }).filter((btn) => {
    if (!btn) return false;
    return btn.style.display !== 'none' && window.getComputedStyle(btn).display !== 'none';
  });
  visibleBtns.forEach((btn, index) => {
    if (index === 0) return;
    const divider = document.createElement('span');
    divider.className = 'client-premium-social-divider';
    divider.setAttribute('aria-hidden', 'true');
    bar.insertBefore(divider, btn);
  });
}

/* Cheia slideshow-ului care rulează (poze + durată): applyClientUI() e rechemat la fiecare snapshot al paginii
   publice (după fiecare joc al oricui), iar repornirea golea fundalul și îl relua de la prima poză — un „flash”
   pe toate telefoanele deschise, inclusiv peste popup-ul cu premiul. Cu aceleași poze nu se mai repornește. */
let activeSlideshowKey = null;

export function stopSlideshow() {
  if (slideshowInterval) {
    clearInterval(slideshowInterval);
    slideshowInterval = null;
  }
  activeSlideshowKey = null;
  const container = $('bgContainer');
  if (container) container.innerHTML = '';
}

function preloadImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

function analyzeImageSalience(img) {
  const w = img.naturalWidth || 0;
  const h = img.naturalHeight || 0;
  if (!w || !h) return null;

  const canvas = document.createElement('canvas');
  const maxDim = 96;
  const scale = maxDim / Math.max(w, h);
  const cw = Math.max(12, Math.round(w * scale));
  const ch = Math.max(12, Math.round(h * scale));
  canvas.width = cw;
  canvas.height = ch;

  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return { aspect: w / h, bestX: 0.5, bestY: 0.62 };

  ctx.drawImage(img, 0, 0, cw, ch);
  let data;
  try {
    data = ctx.getImageData(0, 0, cw, ch).data;
  } catch {
    return { aspect: w / h, bestX: 0.5, bestY: 0.62 };
  }

  const cols = 10;
  const rows = 14;
  let bestScore = -1;
  let bestX = 0.5;
  let bestY = 0.62;

  for (let gy = 0; gy < rows; gy++) {
    for (let gx = 0; gx < cols; gx++) {
      const x0 = Math.floor((gx * cw) / cols);
      const y0 = Math.floor((gy * ch) / rows);
      const x1 = Math.max(x0 + 1, Math.floor(((gx + 1) * cw) / cols));
      const y1 = Math.max(y0 + 1, Math.floor(((gy + 1) * ch) / rows));

      let sumR = 0;
      let sumG = 0;
      let sumB = 0;
      let variance = 0;
      let count = 0;

      for (let y = y0; y < y1; y++) {
        for (let x = x0; x < x1; x++) {
          const i = (y * cw + x) * 4;
          sumR += data[i];
          sumG += data[i + 1];
          sumB += data[i + 2];
          count++;
        }
      }

      const meanR = sumR / count;
      const meanG = sumG / count;
      const meanB = sumB / count;

      for (let y = y0; y < y1; y++) {
        for (let x = x0; x < x1; x++) {
          const i = (y * cw + x) * 4;
          const dr = data[i] - meanR;
          const dg = data[i + 1] - meanG;
          const db = data[i + 2] - meanB;
          variance += dr * dr + dg * dg + db * db;
        }
      }
      variance /= count;

      const cx = (gx + 0.5) / cols;
      const cy = (gy + 0.5) / rows;
      const score = variance;

      if (score > bestScore) {
        bestScore = score;
        bestX = cx;
        bestY = cy;
      }
    }
  }

  return { aspect: w / h, bestX, bestY };
}

function computeSmartBgPositionFromImage(img, { future = false } = {}) {
  const salience = analyzeImageSalience(img);
  if (!salience) return future ? 'center 68%' : 'center 42%';

  const { aspect, bestX, bestY } = salience;
  const xPct = Math.round(Math.min(0.92, Math.max(0.08, bestX)) * 100);

  if (future) {
    // Zona hero Future: subiectul trebuie vizibil integral înainte de cardul galben.
    // background-position Y mai mare = imaginea urcă, se vede mai mult din partea de jos.
    const idealSubjectY = 0.62;
    const subjectY = Math.min(0.88, Math.max(0.38, bestY));
    let yPct = Math.round(subjectY * 100);

    if (aspect < 0.88) {
      yPct = Math.max(yPct, 66);
    } else if (aspect > 1.35) {
      yPct = Math.max(yPct, 62);
    } else {
      yPct = Math.max(yPct, 64);
    }

    const distanceFromIdeal = Math.abs(subjectY - idealSubjectY);
    yPct = Math.round(yPct + distanceFromIdeal * 12 + 4);
    yPct = Math.min(78, Math.max(58, yPct));

    return `${xPct}% ${yPct}%`;
  }

  let y = bestY;
  if (aspect < 0.85) {
    y = Math.min(y, 0.38);
  } else if (aspect > 1.35) {
    y = Math.min(Math.max(y, 0.34), 0.52);
  } else {
    y = Math.min(Math.max(y, 0.3), 0.55);
  }

  const yPct = Math.round(Math.min(0.72, Math.max(0.22, y)) * 100);
  return `${xPct}% ${yPct}%`;
}

function loadImageForSmartBg(url) {
  return new Promise((resolve) => {
    const safe = sanitizeImageSrc(String(url || '').trim());
    if (!safe) {
      resolve(null);
      return;
    }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = safe;
  });
}

async function applySmartBgPositionToSlide(slide, url) {
  if (!slide) return;
  const future = isFutureTemplateActive();
  if (!future) return;

  const img = await loadImageForSmartBg(url);
  const pos = img ? computeSmartBgPositionFromImage(img, { future: true }) : 'center 68%';
  slide.style.backgroundPosition = pos;
  slide.dataset.smartBgPos = pos;

  const container = document.getElementById('bgContainer');
  if (container) {
    const yMatch = /(\d+)%$/.exec(pos);
    const yVal = yMatch ? Number(yMatch[1]) : 68;
    const fadeStart = Math.min(84, Math.max(76, yVal + 10));
    container.style.setProperty('--tpl-future-bg-fade-start', `${fadeStart}%`);
  }
}

export async function applyFutureSmartBgPositions() {
  if (!isFutureTemplateActive()) return;
  const slides = document.querySelectorAll('#bgContainer .bg-slide');
  await Promise.all(
    [...slides].map((slide) => {
      const url =
        slide.dataset.bgUrl ||
        String(slide.style.backgroundImage || '')
          .replace(/^url\(["']?/, '')
          .replace(/["']?\)$/, '');
      return applySmartBgPositionToSlide(slide, url);
    })
  );
}

export function initSlideshow(urls, durationSec) {
  const key = Array.isArray(urls) && urls.length ? `${urls.join('\n')}|${Math.max(Number(durationSec) || 0, 2)}` : null;
  const containerNow = $('bgContainer');
  if (key && key === activeSlideshowKey && containerNow && containerNow.querySelector('.bg-slide')) return;
  stopSlideshow();
  const container = $('bgContainer');
  if (!container) return;

  if (!urls || urls.length === 0) return;
  activeSlideshowKey = key;

  const slides = urls.map((url, index) => {
    const div = document.createElement('div');
    div.className = 'bg-slide';
    div.dataset.bgUrl = url;
    container.appendChild(div);
    return div;
  });

  const applySlideBg = (slide, url, preloadOk) => {
    if (!slide || !url) return;
    slide.style.backgroundImage = `url(${url})`;
    if (preloadOk) applySmartBgPositionToSlide(slide, url);
    else slide.classList.add('bg-slide--failed');
    slide.classList.add('bg-slide--loaded');
  };

  preloadImage(urls[0]).then((ok) => {
    applySlideBg(slides[0], urls[0], ok);
    slides[0].classList.add('active');
  });

  if (urls.length > 1) {
    let loaded = new Set([0]);
    function ensureLoaded(idx) {
      if (loaded.has(idx)) return Promise.resolve();
      loaded.add(idx);
      return preloadImage(urls[idx]).then((ok) => {
        applySlideBg(slides[idx], urls[idx], ok);
      });
    }

    let currentIndex = 0;
    const dur = Math.max(durationSec, 2) * 1000;

    setTimeout(() => { ensureLoaded(1); }, 1200);

    slideshowInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      ensureLoaded(nextIndex).then(() => {
        slides[currentIndex].classList.remove('active');
        currentIndex = nextIndex;
        slides[currentIndex].classList.add('active');
        const preloadIdx = (currentIndex + 1) % slides.length;
        ensureLoaded(preloadIdx);
      });
    }, dur);
  }
}

// ✅ FIX 2: Funcție separată pentru actualizarea butonului bazat pe status (fără slideshow init)
function updatePlayButtonState() {
  const currentSettings = getCurrentSettings();
  if (!currentSettings) return;
  syncPrimaryModuleClientUI(currentSettings);
}

export function applyClientUI() {
  const currentSettings = getCurrentSettings();
  if (!currentSettings) return;

  if (getPublicClientSlug()) {
    applyClientPublicBrandLogo(currentSettings);
  }

  /** Primul paint pe /m/: fără imagini de fundal / promo — hydrate după boot în public-client. */
  const minimalFirstPaint =
    typeof window !== 'undefined' &&
    !!window.__SJ_PUBLIC_MINIMAL_FIRST_PAINT &&
    !!getPublicClientSlug();

  // Folosim bgURLs (array) sau fallback la bgURL (string vechi)
  let bgs = currentSettings?.bgURLs || [];
  if (bgs.length === 0 && currentSettings?.bgURL) {
    bgs = [currentSettings.bgURL];
  }
  if (minimalFirstPaint) {
    bgs = [];
  }

  const duration = parseInt(currentSettings?.slideDuration || 5);
  const clientPageVisible = document.getElementById('clientPage')?.classList.contains('visible');
  const joyPreviewActive =
    typeof document !== 'undefined' &&
    document.body.classList.contains('joy-assistant-active') &&
    document.getElementById('joyAssistantPage')?.classList.contains('visible');
  const connectActive = isConnectTemplateActive();
  const alfaActive = isAlfaTemplateActive();
  const customActive = isCustomTemplateActive();
  if ((connectActive || alfaActive || customActive) && clientPageVisible) {
    stopSlideshow();
  } else if (clientPageVisible || getPublicClientSlug() || joyPreviewActive) {
    initSlideshow(bgs, duration);
  } else {
    stopSlideshow();
  }

  const publicSlug = getPublicClientSlug();
  const socialTapUrl = sanitizeExternalHttpUrl(currentSettings?.clientSocialUrl || '');
  const instagramTapUrl = sanitizeExternalHttpUrl(currentSettings?.clientInstagramUrl || '');
  const websiteTapUrl = sanitizeExternalHttpUrl(
    currentSettings?.clientWebsiteUrl || currentSettings?.menuUrl || ''
  );
  const feedbackTapUrl = sanitizeExternalHttpUrl(currentSettings?.clientFeedbackUrl || '');
  const qr = $('qrImage');
  if (qr) {
    qr.style.display = 'none';
    qr.removeAttribute('src');
  }

  const locationMapFab = document.getElementById('clientLocationMapFab');
  const menuLocationMapBtn = document.getElementById('clientMenuLocationMapBtn');
  const locationMapOn = currentSettings?.locationMapEnabled === true;
  const locationMapUrl = sanitizeExternalHttpUrl(currentSettings?.locationMapUrl || '');
  const showLocationMap = locationMapOn && !!locationMapUrl;
  if (locationMapFab) {
    locationMapFab.style.display = showLocationMap ? 'inline-flex' : 'none';
  }
  if (menuLocationMapBtn) {
    menuLocationMapBtn.style.display = showLocationMap ? 'inline-flex' : 'none';
  }

  applyContactModuleClientUI(currentSettings);

  const locationHoursFab = document.getElementById('clientLocationHoursFab');
  const menuLocationHoursBtn = document.getElementById('clientMenuLocationHoursBtn');
  const locationHoursOn = currentSettings?.locationHoursEnabled === true;
  const locationHoursUrl = sanitizeImageSrc(currentSettings?.locationHoursImageURL || '');
  const showLocationHours = locationHoursOn && !!locationHoursUrl;
  if (locationHoursFab) {
    locationHoursFab.style.display = showLocationHours ? 'inline-flex' : 'none';
  }
  if (menuLocationHoursBtn) {
    menuLocationHoursBtn.style.display = showLocationHours ? 'inline-flex' : 'none';
  }

  const wifiFab = document.getElementById('clientWifiFab');
  if (wifiFab) {
    const wifiOn = currentSettings?.wifiEnabled === true;
    const ssid = String(currentSettings?.wifiSsid || '').trim();
    wifiFab.style.display = (wifiOn && ssid) ? 'inline-flex' : 'none';
    const ssidEl = document.getElementById('wifiPopupSsid');
    const passEl = document.getElementById('wifiPopupPassword');
    if (ssidEl) ssidEl.textContent = ssid || '—';
    if (passEl) passEl.textContent = String(currentSettings?.wifiPassword || '').trim() || '—';
  }

  const communityFab = document.getElementById('clientCommunityFab');
  if (communityFab) {
    const enabled = currentSettings?.communityEnabled === true;
    communityFab.style.display = enabled ? 'inline-flex' : 'none';
  }

  applyMenuModuleClientUI(currentSettings);

  const inAiPreview =
    typeof window !== 'undefined' && window.__aiLayoutPreviewActive === true;

  if (inAiPreview && isAiPreviewStandardPending()) {
    applyStandardTemplateDomFixes(currentSettings);
    syncCompactReviewCard(currentSettings);
  } else {
    const pageEl = document.getElementById('clientPage');
    const tplStyle = getActiveClientTemplateStyleForUi(currentSettings);
    const pending = String(window.__aiTemplatePendingStyle || '').trim().toLowerCase();
    const alreadyOnPending =
      inAiPreview &&
      pending &&
      pending !== 'ai-generated' &&
      pageEl?.classList.contains(`template-${pending}`);
    const aiVariant =
      tplStyle === 'ai-generated' ? (currentSettings?.clientTemplateAiVariant || null) : null;

    if (!isCustomTemplateActive() && !isAvvaTemplateActive()) {
      clearPremiumStageCustomInline();
    }

    /* În preview Modele: tema e deja aplicată de applyAiLayoutModel — nu re-aplica (evită race). */
    if (!inAiPreview && !alreadyOnPending) {
      void applyClientTemplateToPage(tplStyle, { aiVariant, settings: currentSettings }).then(() => {
        schedulePromoIsolation(getCurrentSettings() || currentSettings);
      });
    }

    forceAvvaLayoutShell();

    if (
      isElegantTemplateActive() ||
      isModernTemplateActive() ||
      isDynamicTemplateActive() ||
      isFutureTemplateActive() ||
      isConnectTemplateActive() ||
      isAlfaTemplateActive() ||
      isCustomTemplateActive() ||
      isMinimalTemplateActive() ||
      isAvvaTemplateActive()
    ) {
      syncClientTemplateHeader(currentSettings);
    }
    if (isElegantTemplateActive()) {
      applyElegantTemplateDomFixes();
      syncElegantTopChrome(currentSettings);
      syncElegantClientCopy(currentSettings);
      finalizeElegantReviewVisibility(currentSettings);
    } else if (isConnectTemplateActive()) {
      import('./client-connect-template.js?v=83.58')
        .then((m) => {
          if (!isConnectTemplateActive()) return;
          m.syncConnectTemplate?.(currentSettings);
          schedulePromoIsolation(currentSettings);
        })
        .catch(() => {});
    } else if (isAlfaTemplateActive()) {
      import('./client-alfa-template.js?v=83.58')
        .then((m) => {
          if (!isAlfaTemplateActive()) return;
          m.syncAlfaTemplate?.(currentSettings);
          m.finalizeAlfaDuoChrome?.(currentSettings);
          schedulePromoIsolation(currentSettings);
        })
        .catch(() => {});
    } else if (isCustomTemplateActive()) {
      runCustomTemplateSync(currentSettings);
    } else if (isModernTemplateActive()) {
      applyModernTemplateDomFixes();
    } else if (isDynamicTemplateActive()) {
      applyDynamicTemplateDomFixes();
      syncDynamicClientCopy(currentSettings);
      syncDynamicTemplateAccent(currentSettings);
    } else if (isFutureTemplateActive()) {
      applyFutureTemplateDomFixes();
      syncFutureClientCopy(currentSettings);
      syncFutureTemplateAccent(currentSettings);
      applyFutureSmartBgPositions();
    } else if (isMinimalTemplateActive()) {
      applyMinimalTemplateDomFixes();
      syncMinimalClientCopy(currentSettings);
      syncMinimalOffersCard(currentSettings);
    } else if (isStandardVisualActive()) {
      applyStandardTemplateDomFixes(currentSettings);
      import('./client-standard-template.js?v=83.58')
        .then((m) => m.syncStandardTemplate?.(currentSettings))
        .catch(() => {});
    }
    if (!isElegantTemplateActive()) {
      syncCompactReviewCard(currentSettings);
    }
  }

  // Feedback: tabletă = QR în popup; link public /m/ = tap deschide link (dreapta-sus)
  const feedbackBtn = document.getElementById('feedbackBtn');
  const reviewThanksEl = document.getElementById('clientReviewThanksText');
  const reviewSocialHintEl = document.getElementById('clientReviewSocialHint');
  const reviewDividerEl = document.querySelector('.client-premium-review__divider');
  const reviewSocialBlock = document.querySelector('.client-premium-review__social-block');
  if (feedbackBtn) {
    const fe = currentSettings?.feedbackEnabled === true;
    const savedFeedbackButtonLabel = (currentSettings?.feedbackButtonLabel || '').trim();
    const feedbackLabelText = savedFeedbackButtonLabel || 'Parerea ta!';
    const feedbackCardTitleText =
      savedFeedbackButtonLabel ||
      (currentSettings?.feedbackCardTitle || '').trim() ||
      'Recenzie';
    const feedbackThanksText =
      (currentSettings?.feedbackTitle || '').trim() || 'Îți mulțumim pentru vizită!';

    const resetFeedbackChrome = () => {
      const label = feedbackBtn.querySelector('.feedback-label');
      if (label) label.textContent = feedbackLabelText;
      const cardTitle = feedbackBtn.querySelector('.feedback-title');
      if (cardTitle) {
        cardTitle.textContent = feedbackCardTitleText;
      }
      if (reviewThanksEl && !isAlfaTemplateActive() && !isCustomTemplateActive()) {
        reviewThanksEl.textContent = feedbackThanksText;
      }
    };

    if (!fe) {
      feedbackBtn.style.display = 'none';
      resetFeedbackChrome();
    } else if (feedbackTapUrl || (fe && !publicSlug)) {
      feedbackBtn.style.display = 'flex';
      resetFeedbackChrome();
    } else {
      feedbackBtn.style.display = 'none';
      resetFeedbackChrome();
    }
  }
  // Demo intern: butoanele fără date apar oricum și explică ce se pune acolo
  if (currentSettings?.internalDemo === true) applyDemoPlaceholders(currentSettings);
  const socialIconsBar = document.getElementById('socialIconsBar');
  const minimalTemplate =
    !isAiPreviewStandardPending() &&
    getClientTemplateStyleFromSettings(currentSettings) === 'minimal';
  const socialHintText =
    (currentSettings?.socialCardHint || '').trim() || 'Urmărește-ne pe rețelele sociale';
  if (reviewSocialHintEl) {
    reviewSocialHintEl.textContent = socialHintText;
  }
  if (socialIconsBar) {
    const sm = currentSettings?.socialMedia || {};
    let anyActive = false;
    for (const platform of SOCIAL_PLATFORMS) {
      const p = sm[platform] || {};
      const btn = document.getElementById(`socialBtn${platform.charAt(0).toUpperCase() + platform.slice(1)}`);
      if (btn) {
        const show = p.enabled === true && String(p.link || '').trim();
        btn.style.display = show ? 'flex' : 'none';
        if (show) anyActive = true;
      }
    }
    const compactTemplateActive =
      isElegantTemplateActive() ||
      isModernTemplateActive() ||
      isDynamicTemplateActive() ||
      isFutureTemplateActive();
    if (isMinimalTemplateActive() || minimalTemplate) {
      socialIconsBar.style.display = anyActive ? 'flex' : 'none';
    } else if (isStandardTemplateActive()) {
      socialIconsBar.style.setProperty('display', anyActive ? 'flex' : 'none', 'important');
    } else {
      socialIconsBar.style.display = compactTemplateActive || !anyActive ? 'none' : 'flex';
    }
    if (!isAlfaTemplateActive() && !isCustomTemplateActive() && !isStandardTemplateActive()) {
      syncReviewSocialDividers(socialIconsBar);
    } else {
      socialIconsBar.querySelectorAll('.client-premium-social-divider').forEach((el) => el.remove());
    }
    const reviewShell = document.querySelector('.client-premium-review-shell');
    const alfaActive = isAlfaTemplateActive();
    const customActive = isCustomTemplateActive();
    const standardActive = isStandardTemplateActive();
    if (reviewShell) {
      const feedbackVisible =
        feedbackBtn && feedbackBtn.style.display !== 'none' && window.getComputedStyle(feedbackBtn).display !== 'none';
      if (!alfaActive && !customActive && !standardActive) {
        reviewShell.classList.toggle('client-premium-review-shell--no-feedback', !feedbackVisible);
      } else {
        reviewShell.classList.remove('client-premium-review-shell--no-feedback');
      }
      const hint = reviewShell.querySelector('.client-premium-review__social-hint');
      if (hint) {
        hint.textContent = socialHintText;
        hint.style.display = anyActive && !alfaActive && !customActive && !standardActive ? '' : 'none';
      }
      if (reviewSocialBlock) {
        if (alfaActive || customActive || standardActive) {
          reviewSocialBlock.hidden = false;
          reviewSocialBlock.style.setProperty('display', 'flex', 'important');
        } else {
          reviewSocialBlock.hidden = !anyActive;
          reviewSocialBlock.style.display = anyActive ? '' : 'none';
        }
      }
      if (reviewDividerEl) {
        if (alfaActive || customActive || standardActive) {
          reviewDividerEl.hidden = !anyActive;
          reviewDividerEl.style.setProperty('display', anyActive ? 'block' : 'none', 'important');
        } else {
          const showDivider = feedbackVisible && anyActive;
          reviewDividerEl.hidden = !showDivider;
          reviewDividerEl.style.display = showDivider ? '' : 'none';
        }
      }
      if (reviewThanksEl && !alfaActive && !customActive) {
        reviewThanksEl.style.display = feedbackVisible || standardActive ? '' : 'none';
      }
    }
    if (alfaActive) {
      import('./client-alfa-template.js?v=83.58')
        .then((m) => {
          if (!isAlfaTemplateActive()) return;
          m.refreshAlfaPromoCards?.(currentSettings);
          m.finalizeAlfaDuoChrome?.(currentSettings);
          schedulePromoIsolation(currentSettings);
        })
        .catch(() => {});
    }
    if (customActive) {
      hideCustomIntruders();
      runCustomTemplateSync(currentSettings, { promoOnly: true });
    }
  }

  const clientHeroActions = document.getElementById('clientHeroActions');
  const layoutBlockCampaign = document.getElementById('layoutBlockCampaign');
  const layoutBlockRules = document.getElementById('layoutBlockRules');
  const promoGallery = currentSettings?.clientPromoGallery;
  const promoTitle = String(promoGallery?.title || '').trim();
  const promoHasImages =
    Array.isArray(promoGallery?.images) &&
    promoGallery.images.some((u) => String(u || '').trim());
  const promoShown =
    !minimalFirstPaint &&
    promoGallery?.enabled === true &&
    (promoHasImages || (minimalTemplate && !!promoTitle));
  const loyaltyShown = !minimalFirstPaint && isLoyaltyVisible(currentSettings);
  const eventShown = !minimalFirstPaint && isEventVisible(currentSettings);
  if (clientHeroActions) {
    const locationMenuBtn = document.getElementById('locationMenuBtn');
    const customActive = isCustomTemplateActive();
    const menuShown =
      customActive ||
      (locationMenuBtn &&
        locationMenuBtn.style.display !== 'none' &&
        window.getComputedStyle(locationMenuBtn).display !== 'none');
    const feedbackShown =
      customActive ||
      (feedbackBtn &&
        feedbackBtn.style.display !== 'none' &&
        window.getComputedStyle(feedbackBtn).display !== 'none');
    const reviewCardShown =
      customActive ||
      feedbackShown ||
      (!publicSlug && currentSettings?.feedbackEnabled === true);
    const socialShown =
      socialIconsBar &&
      socialIconsBar.style.display !== 'none' &&
      window.getComputedStyle(socialIconsBar).display !== 'none';

    if (customActive) {
      hideCustomIntruders();
      // CSS face display:contents pe stage/heroActions — curăță eventuale inline vechi
      ['clientPremiumStage', 'clientHeroActions'].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        ['display', 'visibility', 'height', 'min-height', 'max-height',
         'overflow', 'position', 'padding', 'margin', 'z-index'].forEach((p) => el.style.removeProperty(p));
      });
      // Duo: CSS face position:fixed — asigurăm vizibilitate
      const duo = document.getElementById('clientPremiumSectionDuo');
      if (duo) {
        duo.style.setProperty('display', 'grid', 'important');
        duo.style.setProperty('visibility', 'visible', 'important');
        duo.style.setProperty('pointer-events', 'auto', 'important');
        duo.style.setProperty('opacity', '1', 'important');
      }
      runCustomTemplateSync(currentSettings, { promoOnly: true });
    } else if (isAvvaTemplateActive()) {
      // Avva: stage/hero = display:contents (ca restul sheet-ului). Nu forța flex —
      // altfel CTA fidelizare/campanie dispare din stack.
      ['clientPremiumStage', 'clientHeroActions'].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.style.setProperty('display', 'contents', 'important');
        el.style.setProperty('flex', '0 0 auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
      });
      try {
        import('./client-template-style.js?v=83.58')
          .then((m) => m.syncAvvaHeroFrame?.())
          .catch(() => {});
      } catch (_) {
        /* ignore */
      }
    } else {
      clearPremiumStageCustomInline();
      clientHeroActions.style.display =
        menuShown || reviewCardShown || socialShown || promoShown || loyaltyShown
          ? 'flex'
          : 'none';
    }

    const campaignActive = (currentSettings?.campaignStatus || 'draft') === 'active';
    applyClientLayoutConfig(currentSettings, {
      menu: customActive ? true : menuShown,
      review: customActive ? true : reviewCardShown || socialShown,
      social: customActive ? false : socialShown,
      promo: customActive ? false : promoShown,
      campaign: customActive ? false : campaignActive || loyaltyShown || eventShown,
      rules: customActive ? false : campaignActive
    });

    if (customActive) {
      hideCustomIntruders();
    }

    if (isStandardTemplateActive()) {
      import('./client-standard-template.js?v=83.58')
        .then((m) => {
          m.syncStandardChromeMetrics?.(currentSettings);
          m.syncStandardReviewSocial?.(currentSettings);
        })
        .catch(() => {});
    }
  }

  if (!minimalFirstPaint) {
    if (isCustomTemplateActive()) {
      hideGenericPromoGallery();
      runCustomTemplateSync(currentSettings);
    } else {
      if (!isAvvaTemplateActive()) {
        clearPremiumStageCustomInline();
      }
      applyEventModuleUI(currentSettings);
      applyLoyaltyModuleUI(currentSettings);
      syncPrimaryModuleClientUI(currentSettings);
      schedulePromoIsolation(currentSettings);
    }

    const clientPageVisible = document.getElementById('clientPage')?.classList.contains('visible');
    if (clientPageVisible) {
      ensureLoyaltySettingsLoaded(true).then((loaded) => {
        if (!loaded) return;
        const fresh = getCurrentSettings();
        if (!fresh) return;
        if (isCustomTemplateActive()) {
          hideGenericPromoGallery();
          runCustomTemplateSync(fresh);
          return;
        }
        if (!isAvvaTemplateActive()) {
          clearPremiumStageCustomInline();
        }
        applyLoyaltyModuleUI(fresh);
        syncPrimaryModuleClientUI(fresh);
        schedulePromoIsolation(fresh);
        if (isAvvaTemplateActive()) {
          try {
            import('./client-template-style.js?v=83.58')
              .then((m) => m.syncAvvaHeroFrame?.())
              .catch(() => {});
          } catch (_) {
            /* ignore */
          }
        }
      });
    }
  }

  const claimReceiptWrap = $('claimReceiptWrap');
  if (claimReceiptWrap && getPublicClientSlug()) {
    const showReceipt = !!currentSettings?.requireReceiptNumber;
    claimReceiptWrap.style.display = showReceipt ? 'block' : 'none';
    if (!showReceipt) {
      const rInp = $('claimReceiptNumber');
      if (rInp) rInp.value = '';
      const rErr = $('claimReceiptError');
      if (rErr) {
        rErr.style.display = 'none';
        rErr.textContent = '';
      }
    }
  }

  if (!minimalFirstPaint && isMinimalTemplateActive()) {
    syncMinimalOffersCard(currentSettings);
  }

  /* Final pass — fără clearPremiumStage care rupea Avva / dublura oferte */
  if (isCustomTemplateActive()) {
    runCustomTemplateSync(currentSettings);
  } else {
    syncPrimaryModuleClientUI(currentSettings);
    schedulePromoIsolation(currentSettings);
  }
  if (isDynamicTemplateActive()) {
    syncDynamicCentralHero();
  }

  if (isConnectTemplateActive()) {
    import('./client-connect-template.js?v=83.58')
      .then((m) => {
        if (!isConnectTemplateActive()) return;
        m.syncConnectTemplate?.(currentSettings);
        schedulePromoIsolation(currentSettings);
      })
      .catch(() => {});
  } else if (isAlfaTemplateActive()) {
    import('./client-alfa-template.js?v=83.58')
      .then((m) => {
        if (!isAlfaTemplateActive()) return;
        m.syncAlfaTemplate?.(currentSettings);
        m.finalizeAlfaDuoChrome?.(currentSettings);
        schedulePromoIsolation(currentSettings);
      })
      .catch(() => {});
  } else if (isCustomTemplateActive()) {
    runCustomTemplateSync(currentSettings);
  } else {
    schedulePromoIsolation(currentSettings);
  }
}

// ✅ Handle campaign status changes (realtime)
export function handleCampaignStatusChange(newStatus, oldStatus) {
  // ✅ DEBUG C: Log when callback is called
  const currentPage = document.querySelector('.page.visible')?.id || 'unknown';
  const device = navigator.userAgent.includes('Mobile') ? 'mobile' : 'desktop';
  console.log('[handleCampaignStatusChange] CALLED', oldStatus, '->', newStatus, {
    pageId: currentPage,
    device: device
  });
  
  if (newStatus !== 'active') {
    window.closeAllPopups?.();
  }
  
  applyClientUI();
  
  // ✅ FIX: Show message when status changes from active to non-active
  if (oldStatus === 'active' && newStatus !== 'active') {
    const msgEl = document.getElementById('campaignStatusMessage');
    if (msgEl) {
      msgEl.textContent = 'Campania s-a încheiat';
      msgEl.style.display = 'block';
    }
  } else if (oldStatus !== 'active' && newStatus === 'active') {
    // Hide message when status becomes active again
    const msgEl = document.getElementById('campaignStatusMessage');
    if (msgEl) {
      msgEl.style.display = 'none';
    }
  }
}
